<template>
  <div class="animated fadeIn list-of-apreport">
    <b-card>
      <div slot="header">HISTORY TRANSACTION VENDOR/SUPPLIER 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="print()">
              <i class="fa fa-print"></i> Print
          </button>
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col md="4">
            <b-input-group >
                <b-input-group-prepend><label>Supplier/Vendor</label></b-input-group-prepend>
                <b-form-input readonly v-model="model.vendorinfo" ></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuVendorShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group>
        </b-col>
        <b-col md="2">
            <b-input-group >
                <b-input-group-prepend><span class="input-group-text">Currency</span></b-input-group-prepend>
                <b-form-select v-model="model.matauang" :plain="true" :options="currency" ></b-form-select>
            </b-input-group>
        </b-col>
        <b-col md="4">
            <b-input-group >
                <b-input-group-prepend><span class="input-group-text">As of Date</span></b-input-group-prepend>
                <b-form-input v-model="model.tgl2" type="date" placeholder="until date"></b-form-input>
                <b-form-checkbox  class="mt-2 ml-2" v-model="model.alltrx" value=1 unchecked-value=0>Include Old/Closed Invoices</b-form-checkbox>
            </b-input-group>
        </b-col>
        <b-col md="2">
            <b-button class="btn btn-success" @click="getData()" > <i class="fa fa-play"></i> Process</b-button>
        </b-col>
      </b-row>
      <b-card no-body>
          <template v-slot:header v-if="(filterShow=='Hide')">          
            <b-row >
                <b-col lg="3">
                  <b-input-group size="sm" class="mt-1">
                    <b-input-group-prepend><span class="pt-1 mr-1" >FILTER</span></b-input-group-prepend>
                    <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                        ></b-form-input>
                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                    </b-input-group-append>
                    </b-input-group>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>

                </b-col> 
                <b-col lg="9">
                  <b-form-group
                    label="FILTER ON :"
                    label-cols-sm="1"
                    description="Leave all unchecked to filter on all data"
                    class="mb-0">
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="uraian">Description</b-form-checkbox>
                      <b-form-checkbox value="paymethod">Payment Method</b-form-checkbox>
                      <b-form-checkbox value="nomor">A/P Number</b-form-checkbox>
                      <b-form-checkbox value="po">P.O Number</b-form-checkbox>
                      <b-form-checkbox value="invoice">Invoice Number</b-form-checkbox>
                      <b-form-checkbox value="nomorbk">Payment Number</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>                
                </b-col>                 
            </b-row>
        </template>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="rptLines"
                :fields="tblLcy.fields"
                :current-page="tblLcy.page"
                :per-page="tblLcy.limit"
                :sort-by.sync="tblLcy.sortBy"
                :sort-desc.sync="tblLcy.sortDesc"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
              <template v-slot:cell(tanggal)="data">
                  {{ data.item.tanggal | moment("DD-MMM-YYYY") }}
                  <!-- <span v-if="(data.item.tanggal)">{{ data.item.tanggal | moment("DD-MMM-YYYY") }}</span> -->
              </template>
                <template v-slot:cell(nilaibayar)="data">
                      {{ data.item.nilaibayar | numFormat }}
                </template>
                <template v-slot:cell(totalap)="data">
                      {{ data.item.totalap | numFormat }}
                </template>
                <template v-slot:cell(outstand)="data">
                      {{ data.item.outstand | numFormat }}
                </template>
                <template v-slot:cell(iDocsURL)="data">
                <b-link @click="open_iDocs(data.item)" v-if="(data.item.iDocsURL)">iDoc</b-link>
              </template>

            </b-table>
            <b-row class="mt-2">
                <b-col lg="8">
                    <b-row >
                      <b-col cols="8">
                      <b-input-group>
                          <b-input-group-prepend><span class="pt-1 pr-2">Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                          to <span v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)">{{tblLcy.total}}</span> <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                          of {{tblLcy.total}} entries, </span></b-input-group-prepend> 
                          <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
                          <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px !important;"></b-form-input>  
                          <b-pagination
                            v-if="pagination" 
                            :total-rows="tblLcy.total"
                            :per-page="tblLcy.limit"
                            v-model="tblLcy.page"
                          ></b-pagination>
                      </b-input-group>
                      </b-col>
                      <b-col cols="4">            
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-2">
                          <b> {{ filterShow }}</b>  Filter
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                </b-col>
                <b-col lg="4">
                  <b-form-row>
                    <b-col md="4">
                      <b-form-group label="Total Debit (LCY)" >
                          <my-number class="form-control text-right" v-model="subtotal.debit" :precision="2" disabled></my-number>
                      </b-form-group>                  
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Total Credit (LCY)" >
                            <my-number class="form-control text-right" v-model="subtotal.credit" :precision="2" disabled></my-number>
                        </b-form-group>                  
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="End. Balance (LCY)" >
                            <my-number class="form-control text-right" v-model="subtotal.outstand" :precision="2" disabled></my-number>
                        </b-form-group>                  
                    </b-col>
                  </b-form-row>
                </b-col>
            </b-row>
      </b-card>

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuVendorShow" size="lg" :hide-footer="true" title="List of Vendor" :centered="true">
            <lku-vendor @click="onSelectLkuVendor"></lku-vendor>
        </b-modal>        

  </div>
</template>

<style lang="scss" scoped>
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 2px;
                width: 110px;
            }
        }
    }
 
</style>

<script>
import moment from 'moment';
import myNumber from "../../components/my-number";
import apreport from "../../apis/apreport";
import lkuVendor from "../lookup/lkuVendor";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        vendor: { required },
        matauang: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      horizontal: true,
      isLoading:false,
      showReport:false,
      lkuVendorShow:false,
      reportUrl: null,
      model: {vendor:'',matauang:this.$store.state.user.matauang, tgl2:'', alltrx:0},
      currency: [],
      rptLines : [],
      filterShow:'Show',
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
            {
                key: "tanggal",
                label: "Trx. Date",
                thStyle: "width:90px",
                thClass: "text-center",
                tdClass: "text-center",
                sortable: true
            },
            {
                key: "nomor",
                label: "AP Number",
                sortable: true
            },
            {
                key: "po",
                label: "P.O No.",
                thStyle: "width:90px",
                sortable: true
            },
            {
                key: "invoicepo",
                label: "Invoice #",
                thStyle: "width:90px",
                sortable: true
            },
            {
                key: "nomorbk",
                label: "Payment Number",
                sortable: true
            },
            {
                key: "uraian",
                label: "Description",
            },
          {
            key: "iDocsURL",
            label: "",
            thClass:"text-center",
            tdClass:"text-center",
          },
            {
                key: "paymethod",
                label: "Pay Method",
                thStyle: "width:90px",
                sortable: true
            },
            {
                key: "matauang",
                label: "Rp,$,¥",
                thStyle: "width:40px",
                sortable: true
            },
            {
                key: "nilaibayar",
                label: "Debit",
                thStyle: "width:120px",
                thClass: "text-right",
                tdClass: "text-right",
                sortable: true
            },
            {
                key: "totalap",
                label: "Credit",
                thStyle: "width:120px",
                thClass: "text-right",
                tdClass: "text-right",
                sortable: true
            },
            {
                key: "outstand",
                label: "End Balance",
                thStyle: "width:120px",
                thClass: "text-right",
                tdClass: "text-right",
                sortable: true
            },
            {
                key: "aging",
                label: "Age(days)",
                thStyle: "width:40px",
                thClass: "text-center",
                tdClass: "text-center",
                sortable: true
            },
        ]
      },
      pagination: false,
      limit:15,
      filter: null,
      filterOn: [],   
      subtotal :{debit: 0, credit:0 , outstand:0}
    };
  },
  components: {Loading,lkuVendor,myNumber},
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },  
  created: async function(){
        this.currency = await apreport.currency();
    //   const matauang = await apreport.currency();
    //   this.currency = matauang.reduce((newArr,item) =>{
    //         newArr.push(item);
    //         return newArr;
    //     },[{ value: '', text: '-ALL-'}]);

        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.model.tgl1=this.$store.state.user.tglaktif;
        this.model.tgl2=tgl2.format('YYYY-MM-DD');
  },  
  watch: {
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblLcy.limit=newVal;
        }
      }, 500);
    },    
  },
  methods: {
    async open_iDocs(doc) {
      this.$open_iDocs(doc, (state) => this.isLoading = state);
    },

    onSelectLkuVendor: async function (_selected) {
        this.model.vendorinfo = _selected.vendor_name.trim() + ' | ' + _selected.vendor_code.trim();
        this.model.vendor = _selected.vendor_code;
        this.lkuVendorShow=false;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
      // this.totalBank_in = filteredItems.reduce((a, b) => a + b.bank_in, 0);
      // this.totalBank_out = filteredItems.reduce((a, b) => a + b.bank_out, 0);
    },     
    clearFilter() {
          this.filterOn= []   
          this.filter= '';   
    } ,
    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.pagination=false;
        this.isLoading=true;
        const result = await apreport.trxvendor(this.model);   
        if (result.success) {
            this.rptLines = result.data[0];   
            this.subtotal = result.data[2];
            this.tblLcy.total = this.rptLines.length;        
        } else {
          toastr.error(result.message,'ERROR',10000);
        }
        this.isLoading=false;      
        this.pagination=true;
       }
    },
    confirmAction: function() {
        toastr.info('Klik Pada TRX. NUMBER untuk PRINT VOUCHER');
    },
    printJv: async function(data){
        this.showConfirmAction=false;
        this.showList=false;
       if ((data.nomor !== 'BEGINING') && (data.nomor !== '')) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await apreport.printjv(data);
              this.isLoading=false;    
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } 
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                this.showReport=true;
                this.reportUrl= await apreport.trxvendorprint(this.model);
                this.isLoading=false;    
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await apreport.trxvendorexport(this.model);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
      }
    },    
    close(){
      router.push("home");
    }
  }
};
</script>
